module.exports = __webpack_public_path__ + "media/slide3-click-action.4dc007b9.mp4";